import { render, staticRenderFns } from "./MappingItemResources.vue?vue&type=template&id=9a9ab67e"
import script from "./MappingItemResources.vue?vue&type=script&lang=js"
export * from "./MappingItemResources.vue?vue&type=script&lang=js"
import style0 from "./MappingItemResources.vue?vue&type=style&index=0&id=9a9ab67e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports